export const ONE_MINUTE_MILLISECONDS = 60 * 1000;
